// extracted by mini-css-extract-plugin
module.exports = {"trail":"trail_trail__2WgpM","img":"trail_img__3wAQ-","caption":"trail_caption__1O8zP","checkbox":"trail_checkbox__TK4pd"};